<template>
    <va-create-layout>
        <MwsConfiguration-form
            :title="title"
            :item="item"
        ></MwsConfiguration-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
